import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

const SubmitButton = ({ isDisabled, submitKey, type = 'submit', ...rest }) => {
  return (
    <Button
      disabled={isDisabled}
      htmlType={type}
      type="primary"
      size="large"
      {...rest}
    />
  );
};

SubmitButton.propTypes = {
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.any,
  href: PropTypes.string,
  submitKey: PropTypes.string,
  type: PropTypes.string,
};

export default SubmitButton;
